import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from './types';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function ArrowFromBracketIcon({ color: colorProp }: IconProps) {
  const theme = useTheme();

  const color = colorProp || theme.colors.chartChartBlueSecondary2100;

  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3046_1486)">
        <path
          d="M15.7787 8.4812C16.0725 8.18748 16.0725 7.71252 15.7787 7.42193L11.7791 3.41919C11.4854 3.12547 11.0104 3.12547 10.7199 3.41919C10.4293 3.71291 10.4261 4.18787 10.7199 4.47846L13.4383 7.19695L5.74846 7.19695C5.33288 7.19695 4.99853 7.53129 4.99853 7.94687C4.99853 8.36246 5.33288 8.6968 5.74846 8.6968L13.4383 8.6968L10.7199 11.4153C10.4261 11.709 10.4261 12.184 10.7199 12.4746C11.0136 12.7652 11.4885 12.7683 11.7791 12.4746L15.7787 8.4812ZM5.24851 2.45054C5.6641 2.45054 5.99844 2.11619 5.99844 1.70061C5.99844 1.28503 5.6641 0.950683 5.24851 0.950683L2.74876 0.950683C1.23015 0.950683 -0.000976616 2.18181 -0.000976683 3.70041L-0.000977054 12.1996C-0.000977121 13.7182 1.23015 14.9493 2.74875 14.9493L5.24851 14.9493C5.6641 14.9493 5.99844 14.615 5.99844 14.1994C5.99844 13.7838 5.6641 13.4495 5.24851 13.4495L2.74875 13.4495C2.0582 13.4495 1.49888 12.8901 1.49888 12.1996L1.49888 3.70041C1.49888 3.00986 2.0582 2.45054 2.74876 2.45054L5.24851 2.45054Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_3046_1486">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ArrowFromBracketIcon;
